var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        right: _vm.selectAll,
        left: !_vm.selectAll,
        "offset-x": "",
        "close-on-content-click": _vm.activityMenu
          ? _vm.activity.company && _vm.activity.company.length >= 2
          : false,
        "nudge-width": "250",
        "nudge-bottom": _vm.activityMenu ? "30" : "0",
        "max-height": "300px"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "button",
                      attrs: {
                        icon: "",
                        small: "",
                        disabled: _vm.activityMenu
                          ? _vm.activity.company &&
                            !!_vm.activity.company.find(function(item) {
                              return (
                                item.type === "web" ||
                                item.type === "mobile" ||
                                _vm.activity.company.length >= 2
                              )
                            })
                          : _vm.disabledView
                      }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                )
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("v-text-field", {
        staticClass: "text-input-height",
        attrs: {
          placeholder: _vm.$tc("SearchCompanyOrUser"),
          clearable: "",
          color: "accent"
        },
        model: {
          value: _vm.searchUserAndCompany,
          callback: function($$v) {
            _vm.searchUserAndCompany = $$v
          },
          expression: "searchUserAndCompany"
        }
      }),
      _vm._v(" "),
      _c("AssignmentMenuListItem", {
        attrs: {
          activityMenu: _vm.activityMenu,
          searchUserAndCompany: _vm.searchUserAndCompany,
          isUser: true,
          filteredAssignees: _vm.filteredUsers
        },
        on: {
          addIndividualUser: function($event) {
            return _vm.$emit("addIndividualUser", $event)
          },
          addCompanyOrUser: function($event) {
            return _vm.$emit("addCompanyOrUser", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("AssignmentMenuListItem", {
        attrs: {
          activityMenu: _vm.activityMenu,
          isUser: false,
          searchUserAndCompany: _vm.searchUserAndCompany,
          filteredAssignees: _vm.filteredCompanies
        },
        on: {
          addIndividualUser: function($event) {
            return _vm.$emit("addIndividualUser", $event)
          },
          addCompanyOrUser: function($event) {
            return _vm.$emit("addCompanyOrUser", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f555d4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f555d4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Organisms/AssignmentMenu.vue
// module id = null
// module chunks = 